import {Injectable} from '@angular/core';
import {PaymentCardReaderModel} from "../entity/paymentCardReader.model";
import {PaymentCardReaderSummaryModel} from "../entity/paymentCardReaderSummary.model";
import {PaymentCardReaderRepository} from "../../impl/service/repository/paymentCardReader.repository";
import {PaymentCardReaderSummaryDataServiceAdapter} from "../../impl/service/repository/paymentCardReaderSummary.dataserviceadapter";
import {AbstractFindAllService} from "src/app/modules/core/service/v2/service/findAll/abstractFindAll.service";

@Injectable()
export class PaymentCardReaderSummaryFindAllService extends AbstractFindAllService<PaymentCardReaderModel, PaymentCardReaderSummaryModel>{
    constructor(repository: PaymentCardReaderRepository, serviceAdapter: PaymentCardReaderSummaryDataServiceAdapter) {
        super(repository, serviceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
